var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"hide-details":"","value":_vm.setectVale,"lable":_vm.lable},on:{"input":function($event){return _vm.changeData($event)}}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }